<template>
  <div>
    <v-card
      class="mx-auto mt-5 mb-5"
      max-width="1200"
      outlined
      v-intersect="{
        handler: onIntersect,
        options: {
          rootMargin: '-80px'
        }
      }"
      ref="articletop"
    >
      <ArticleHeader
        :article="article"
        @updatedata="updateArticleHandler"
        @enteringScreen="headerEnteringScreenHandler"
        @leavingScreen="headerLeavingScreenHandler"
      ></ArticleHeader>

      <v-container v-for="infopair in article.infopairs" :key="infopair.id" class="pa-0 ma-0">
        <InfoPairComponent
          :infopair="infopair"
          @updatedata="updateInfoPairHandler"
          :published="!!article.publication_date"
        ></InfoPairComponent>
      </v-container>
      <v-row align="center" justify="center">
        <v-btn
          v-if="adminMode && !!!article.publication_date"
          color="green"
          x-large
          dark
          :loading="apiLoadingData"
          @click="submitArticle"
        >Опубликовать</v-btn>
      </v-row>
      <CommentsList :article="article"></CommentsList>
    </v-card>
  </div>
</template>

<script>
import { showDate } from '@/helpers/helpers.js'
import { authComputed } from '@/store/helpers.js'
import { adminOptionsComputed } from '@/store/helpers.js'

import { editingLogicMixin } from '@/components/mixins/editing'

import APIService from '@/apiservices/APIService.js'

import CommentsList from '@/components/CommentsList.vue'
import ArticleHeader from '@/components/ArticleHeader.vue'
import InfoPairComponent from '@/components/InfoPairComponent.vue'

import Vue from 'vue'

export default {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  components: {
    CommentsList,
    ArticleHeader,
    InfoPairComponent
  },
  mixins: [editingLogicMixin],
  data() {
    return {
      offsetTop: 0
    }
  },
  computed: {
    ...adminOptionsComputed,
    ...authComputed
  },
  /*
  mounted() {
    this.$vuetify.goTo(this.$refs.articletop, { offset: 100 })
  },
  */
  methods: {
    showDate,

    updateArticleHandler(article) {
      Object.assign(this.article, article)
      //this.article.title = article.title
      //this.article.event_date = article.event_date
      console.log('in update handler:', article)
    },

    updateInfoPairHandler(infopair) {
      var foundIndex = this.article.infopairs.findIndex(
        x => x.id == infopair.id
      )
      Vue.set(this.article.infopairs, foundIndex, infopair) //специальная функци для обеспечения реактивности прри апдейте элемента массива
    },

    // eslint-disable-next-line no-unused-vars
    onIntersect(entries, observer) {
      if (entries[0].isIntersecting) {
        this.$emit('enteringScreen', this.article)
      } else {
        if (entries[0].boundingClientRect.y < 84) {
          this.$emit('leavingScreen', this.article)
        }
      }
    },

    headerEnteringScreenHandler(article) {
      this.$emit('headerEnteringScreen', article)
    },
    headerLeavingScreenHandler(article) {
      this.$emit('headerLeavingScreen', article)
    },
    dataUpdated(article) {
      this.$router.push('/article/' + article.id)
    },
    setData() {
      const apiData = {}
      apiData.publication_date = new Date()
      apiData.author = this.loggedUserPersonId
      apiData.infopairs = []
      return apiData
    },

    submitArticle() {
      this.updateData(APIService.updateArticle, this.article.id)
    }
  }
}
</script>
